export const APTITUDE_SKILLS = "/api/pa/aptitude-skills"
export const APTITUDE_SKILL = "/api/pa/aptitude-skills/:param"
export const APTITUDE_SKILL_ACTIVATE = "/api/pa/aptitude-skills/:param/activate"
export const EXPORT_APTITUDE_SKILL = "/api/pa/aptitude-skills/export"
export const IMPORT_APTITUDE_SKILL = "/api/pa/aptitude-skills/import"
